var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15.001,
    viewBox: "0 0 17 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M3745.5,12834h-.012a1.5,1.5,0,0,1-1.042-.425,1.453,1.453,0,0,1-.445-1.038v-7.907a1.5,1.5,0,0,1,1.5-1.468h2.559v-1.692a1.465,1.465,0,0,1,.445-1.044,1.512,1.512,0,0,1,1.06-.425h4.871a1.473,1.473,0,0,1,1.051.425,1.456,1.456,0,0,1,.445,1.039v1.7h2.565a1.6,1.6,0,0,1,1.051.423,1.451,1.451,0,0,1,.448,1.038v7.914a1.443,1.443,0,0,1-.448,1.038,1.537,1.537,0,0,1-1.057.425Zm-.126-9.365v7.9a.111.111,0,0,0,.121.112H3758.5a.135.135,0,0,0,.127-.115v-7.9c0-.053-.065-.1-.121-.114H3745.5A.138.138,0,0,0,3745.372,12824.636Zm13.95,7.9h-.009Zm-9.851-11.14a.1.1,0,0,0-.035.082v1.688h5.13v-1.692a.147.147,0,0,0-.124-.113h-4.88a.138.138,0,0,0-.036-.006C3749.489,12821.352,3749.482,12821.379,3749.471,12821.393Zm1.844,8.768v-.9h-.939a.678.678,0,1,1,0-1.356h.939v-.9a.685.685,0,0,1,1.369,0v.9h.943a.678.678,0,1,1,0,1.356h-.943v.9a.685.685,0,0,1-1.369,0Z",
    transform: "translate(-3743.499 -12819.5)",
    fill: "#909aac",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceItem);
export default __webpack_public_path__ + "static/media/service_item.23479f66210f5d7f3fa4afdba805f5da.svg";
export { ForwardRef as ReactComponent };